import React from "react";
import Card from "react-bootstrap/Card";
import { BsRecordFill } from "react-icons/bs";
import { AdvancedExample } from "../Pagination";
import { alteraData, truncateText, trimSlashes } from "../utils";
import { Dicas } from "../Dicas";

export const Resultados = ({
  result,
  getHighlightContent,
  toggleExpanded,
  expandedItems,
  page,
  handlePageSelected
}) => {
  return (
    <>
      <div className="mt-3">

        {result === undefined || result.docs === undefined ? (
          <Dicas />
        ) : result.docs.length > 0 ? (
          <>
            <ol className="posts">
              {result.docs?.map((todo) => (
                <div key={todo.id}>
                  <Card className="Post" key={todo.id} style={{ width: "auto" }}>
                    <Card.Body>
                      <Card.Title>
                        <div className={`d-flex justify-content-between`}>
                          <Card.Link
                            className="titulo"
                            href={
                              "https://cdn.mpma.mp.br/legislacao/" +
                              trimSlashes(todo.uri_arquivo)
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {`${todo.tipo} ${todo.numero === undefined
                              ? "S/N - " + todo.ano
                              : "nº " + todo.numero + "/" + todo.ano
                              } - ${todo.origem_sigla}`}
                          </Card.Link>
                          <div className="acesso ">
                            {alteraData(`${todo.data_publicacao}`)}
                          </div>
                        </div>
                      </Card.Title>
                      <Card.Text>
                        {truncateText(todo.ementa, 200000)}
                        {getHighlightContent !== null && getHighlightContent(todo.id) && (
                          <div
                            className="trecho"
                            dangerouslySetInnerHTML={{
                              __html: getHighlightContent(todo.id).join(" "),
                            }}
                          />
                        )}
                      </Card.Text>
                      <div className={`Situacao d-flex justify-content-end align-items-center`}>
                        <div
                          className={`${todo.situacao === "Em vigor"
                            ? "SituacaoEmVigor"
                            : todo.situacao === "Alterada"
                              ? "SituacaoAlterada"
                              : todo.situacao === "Revogada"
                                ? "SituacaoRevogado"
                                : "SituacaoAnulada"
                            }`}
                        >
                          <BsRecordFill style={{ fontSize: '1rem' }} />
                        </div>
                        {todo.situacao}
                      </div>
                      <ul className="Lista1">
                        {todo.relacionados?.map((relacionado) => (
                          <li key={relacionado.id}>
                            {relacionado.relacionados.length > 0 && (
                              <div
                                onClick={() => toggleExpanded(relacionado.id)}
                                className={`Toggle-button ${expandedItems[relacionado.id] ? "expanded" : ""
                                  }`}
                              >
                                {expandedItems[relacionado.id] ? "▼" : "►"}
                                <span style={{ fontSize: "0.8rem" }}>
                                  Normas relacionadas
                                </span>
                              </div>
                            )}
                            {expandedItems[relacionado.id] &&
                              relacionado.relacionados.length > 0 && (
                                <ul>
                                  {relacionado.relacionados?.map(
                                    (relacionadoInterno) => (
                                      <li
                                        className={`menu-item ${expandedItems[relacionadoInterno.id]
                                          ? "expanded"
                                          : ""
                                          }`}
                                        key={relacionadoInterno.id}
                                      >
                                        {relacionadoInterno.situacao === "Revogada" || relacionadoInterno.situacao === "Anulada" ? (
                                          <a
                                            className="relacionado text-secondary"
                                            href={
                                              "https://cdn.mpma.mp.br/legislacao/" +
                                              trimSlashes(
                                                relacionadoInterno.uri_arquivo
                                              )
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            {`${relacionadoInterno.descricao} nº ${relacionadoInterno.numero}/${relacionadoInterno.ano} (${relacionadoInterno.situacao})`}
                                          </a>
                                        ) : (
                                          <a
                                            className="relacionado"
                                            href={
                                              "https://cdn.mpma.mp.br/legislacao/" +
                                              trimSlashes(
                                                relacionadoInterno.uri_arquivo
                                              )
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            {`${relacionadoInterno.descricao} nº ${relacionadoInterno.numero}/${relacionadoInterno.ano}`}
                                          </a>
                                        )}

                                      </li>
                                    )
                                  )}
                                </ul>
                              )}
                          </li>
                        ))}
                      </ul>
                    </Card.Body>
                  </Card>
                </div>
              ))}
            </ol>
            <div className="paginacao d-flex justify-content-center">
              <AdvancedExample
                totalPages={Math.ceil(result.numFound / 12)}
                onPageSelected={handlePageSelected}
                selectedPage={page}
              />
            </div>
          </>
        ) : (
          <div className="text-center text-secondary mt-3">Nenhum resultado encontrado.</div>
        )}
      </div>
    </>
  );
};
